module.exports = __webpack_public_path__ + "static/media/cafe_03.0b7f2a13.svg";